#import "./CanvasBlockBaseFields.graphql"

fragment MeetingSummaryBlockFields on MeetingSummaryBlock {
  ...CanvasBlockBaseFields
  body
}
